import axios from "axios";
import * as URL from "../helpers/Constants";

export default class FormSubmissionServices {

    // static getAllFormSubmissions(params) {
    //     return axios.get(`${URL.FORM_SUBMISSION_GET_ALL}`, {
    //         params, ...FormSubmissionServices.getAuthHeader()
    //     })
    // }

    static generateFormSubmissionExcelReport(params) {
        return axios.get(`${URL.FORM_SUBMISSION_GENERATE_EXCEL_REPORT}`, {
            params,
            responseType: "blob",
            ...FormSubmissionServices.getAuthHeaderForFileDownload()
        })
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return { headers: { "Authorization": `Bearer ${accessToken}` } };
    }

    static getAuthHeaderForFileDownload = () => {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Response-Type": "blob",
            },
        };
    };
}
